import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import OutboundCall from './icon-outbound-call.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <OutboundCall {...validProps} />;
}
SvgComponent.iconName = 'outboundCall';

/**
 * @deprecated This is a legacy icon
 */
export const OutboundCallIcon = svgIconWrapper(SvgComponent);
